import liff from "@line/liff";

export const liffReady = () => liff.ready;


export const getLineUserId = () => {
  return liff.getContext().userId;
};

export const sendMessages = async (messages) => {
  return liff.sendMessages(messages)
}

export const closeWindow = () => {
  liff.closeWindow();
}
